import { RECEIVE_DATA, CLEAR_DATA } from "./realTimeDataActions";

// Initial state exactly as requested
const initialState = {
  methodType: null,   // post | update | delete
  dataModel: null,    // patient | visit | etc.
  data: null,         // payload
  from: null,         // userId
  createdAt: null,    // timestamp
};

const realTimeDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_DATA:
      return {
        ...state,
        ...action.payload, // overwrite with new incoming data
      };

    case CLEAR_DATA:
      return { ...initialState }; // reset to empty

    default:
      return state;
  }
};

export default realTimeDataReducer;
